import React from "react"
import Link from './link'
import Image from "./image";
import {LogoIcon} from "./icons";

const FavoriteHome = ({ data = [] }) => (
  <div className={'favorite-home'}>
    <ul>
      {
        data.map(item => (
          <li key={ item.key }>
            <Link
              to={`/privilege-detail`}
              state={{ privilegeCode: item.privilegeCode }}
            >
              <Image PlaceholderComponent={
                <div
                  className={'coupon-wisdom-logo-box with-placeholder'}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <LogoIcon svg={{ height: '4em', className: 'coupon-wisdom-logo' }}/>
                </div>}
                     src={item.imgPrivilege}
              />
              <div className={'favorite-title'}>{ item.title }</div>
              <div className={'favorite-date'}>{ item.date }</div>
            </Link>
          </li>
        ))
      }
    </ul>
  </div>
)

export default FavoriteHome
